$ = require 'jquery'
_ = require 'underscore'
debounceSignal = require 'lib/util/debounce-signal'
Hearsay = require 'hearsay'
Keyboard = require 'lib/keyboard'
Keys = require 'data/keys'
pluginValidators = require 'lib/plugins/plugin-validators'
PluginView = require 'views/plugin/plugin-view'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
t = require('views/internal/teacup-with-helpers')('plugin_popover')
Util = require 'lib/util'
xtend = require 'xtend'

outerTemplate = t.renderable (content = {}) ->
  { showSearch, search } = content

  if search && showSearch
    t.input '.js-search.js-autofocus', { type: 'text', placeholder: search.placeholder }

  t.div '.js-results'
  return

resultsTemplate = t.renderable ({ search, noSearchResults, items, selectedIndex }) ->
  if noSearchResults
    t.p '.empty.plugin-pop-over-search-empty', ->
      if search.empty
        t.text search.empty
      else
        t.format 'no results'
      return

  t.ul '.pop-over-list.js-list.navigable', ->
    for { text, index, callback, url } in items
      selected = index == selectedIndex
      t.li { class: t.classify({ selected }) }, ->
        linkOpts = if callback?
          'data-index': index
        else if url? && pluginValidators.isValidUrlForIframe(url)
          href: url
          rel: 'noreferrer nofollow noopener'
          target: url

        t.a linkOpts, ->
          t.text text
          return
        return
    return

  return

searchingTemplate = t.renderable ({ search } = {}) ->
  t.p '.quiet.plugin-pop-over-search-searching', ->
    if search?.searching
      t.text search.searching
    else
      t.format 'searching'
    return


module.exports = class PluginPopOverListView extends PluginView
  initialize: ({ @title, @content }) ->
    @retain(@content)

    @searchText = @slot('')

  getViewTitle: -> @title

  keepInDOM: true

  events: ->
    'click a[data-index]': (e) ->
      index = parseInt($(e.currentTarget).attr('data-index'), 10)
      if _.isFunction(@content.items)
        item = @content.searchResults[index]
      else
        item = @content.items[index]
      item.callback
        el: e.currentTarget
      .done()

    'click a[href]': (e) ->
      PopOver.hide()

    'input .js-search': (e) ->
      @searchText.set $(e.currentTarget).val()

    'mouseenter li': (e) ->
      Util.selectMenuItem(@$('.js-list'), 'li', $(e.currentTarget))

    'keydown': (e) ->
      key = Keyboard.getKey(e)
      $list = @$('.js-list')

      if key in [Keys.ArrowUp, Keys.ArrowDown]
        Util.stop(e)
        Util.navMenuList($list, 'li', key)
      else if key in [Keys.Enter, Keys.Tab]
        Util.stop(e)
        $list.find('li.selected a').click()
      return

  renderOnce: ->
    isDynamicSearch = _.isFunction(@content.items)

    @$el.html outerTemplate
      search: @content.search
      showSearch: @content.search && (isDynamicSearch || @content.items.length > @content.search.count)

    $results = @$el.find('.js-results')
    getItems = (searchText) =>
      Promise.try =>
        if isDynamicSearch
          @content.items
            options:
              search: searchText
        else
          items = @content.items
          items = items.map (item, index) ->
            xtend item, { index }

          if @content.search
            if searchText
              satisfiesFilter = Util.buildFuzzyMatcher(searchText)
              items = items.filter ({ text, alwaysVisible }) ->
                (alwaysVisible || satisfiesFilter(text))

            if (limit = @content.search?.count)?
              filterCount = 0
              items = _.filter items, (item, index) ->
                if item.alwaysVisible
                  true
                else if filterCount < limit
                  filterCount++
                  true
                else
                  false

          items
      .then (items) =>
        if isDynamicSearch
          @content.searchResults = items.map (item, index) ->
            xtend item, { index }
          @retain(@content.searchResults)
          @content.searchResults
        else
          items

    if @content.search
      debounceDelay = 300
      if _.isFinite(@content.search.debounce) && @content.search.debounce > debounceDelay
        # only allow the debounce to be increased, not decreased
        debounceDelay = @content.search.debounce
      debouncedSearch = debounceSignal @searchText, debounceDelay
      @subscribe debouncedSearch, (searchText) =>
        $results.html(searchingTemplate(search: @content.search))

        if @_outstandingSearch?
          # we have an outstanding search request that we should cancel
          @_outstandingSearch.cancel()

        @_outstandingSearch = getItems(searchText).cancellable()

        @_outstandingSearch.then (items) =>
          @_outstandingSearch = null
          noSearchResults = !_.any items, ({ alwaysVisible }) -> !alwaysVisible
          selectedIndex = items[0]?.index ? -1
          $results.html(resultsTemplate({ search: @content.search, noSearchResults, items, selectedIndex }))
    else
      $results.html(searchingTemplate())

      getItems()
      .then (allItems) ->
        $results.html(resultsTemplate({ items: allItems, selectedIndex: 0 }))

    @



// WEBPACK FOOTER //
// ./app/scripts/views/plugin/plugin-pop-over-list-view.coffee